export const UrlApi = "https://dgfexpress-system.com/api/";     //ตอน Build
export const path = "/dgf-express";   //ตอน Build
// export const UrlApi = "http://localhost:9000/api/";
// export const path = "";
export const sitekey = "6LfB3yMlAAAAAKGfE9ydGHUWuFniP2PpULszDXgU";
export const authorization = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
};

// export const sitekeyLocal = "6LesE4IkAAAAAL56-T4XX6QKuWH1j__OuWRDq6xi";
// export const sitekeyDomainDGF = "6LfB3yMlAAAAAKGfE9ydGHUWuFniP2PpULszDXgU";
//http://localhost:9000/api/
//https://dgfexpress-system.com/api/
//https://dgfexpress-system.com/dgf-express/ หน้าบ้าน
//